export const SET_ALL_PROFESSION = 'set_all_profession';
export const CHANGE_CAT_PARAMS = 'change_cat_params';
export const TOGGLE_MODAL = 'toggle-modal';
export const SELECT_CAT = 'select-cost';
